var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.908,
    height: 16.051,
    viewBox: "0 0 9.908 16.051",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5986",
    "data-name": "Group 5986",
    transform: "translate(5188 -3951)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18043",
    "data-name": "Path 18043",
    d: "M182.143,0a4.949,4.949,0,0,1,4.926,4.981,5.268,5.268,0,0,1-1,3.044l-3.985,5.314-3.874-5.314A4.969,4.969,0,0,1,182.142,0Zm0,2.159a2.8,2.8,0,0,1,2.823,2.823A2.835,2.835,0,0,1,182.143,7.8a2.8,2.8,0,0,1-2.823-2.823A2.766,2.766,0,0,1,182.143,2.159Z",
    transform: "translate(-5365.161 3951)",
    fill: "#2a2a2a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18044",
    "data-name": "Path 18044",
    d: "M259.953,499.091c0,.489-1.239.886-2.767.886s-2.767-.4-2.767-.886,1.239-.886,2.767-.886,2.767.4,2.767.886",
    transform: "translate(-5440.204 3467.075)",
    fill: "#2a2a2a",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.68693b6c109970590b5369979527c8c9.svg";
export { ForwardRef as ReactComponent };